import React, { memo } from 'react';

import { DocumentIFrame } from './Document.styled';

export interface IDocumentProps {
  src: Blob | MediaSource;
  title: string | undefined;
}

const Document = ({ src, title }: IDocumentProps) => {
  const blob = URL.createObjectURL(src);
  const viewerPath = `${process.env.PUBLIC_URL}/pdfjs/web/viewer.html?file=${encodeURIComponent(
    blob,
  )}`;

  return <DocumentIFrame title={title ? title : 'Document'} src={viewerPath} />;
};

export const MemoizedDocument = memo(Document);
